import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './NumberDropdown.css';
import React, { useRef, useState } from 'react';
import { get } from '../../utils';
import { removeQueryString, default as addQueryString, deleteQueryString } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';

// let facetFilters: any = convertQueryParamsToFacets(queryParams);

var useDebounce = function useDebounce(value, timeout) {
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  React.useEffect(function () {
    var handler = setTimeout(function () {
      return setState(value);
    }, timeout);
    return function () {
      return clearTimeout(handler);
    };
  }, [value, timeout]);
  return state;
};
var NumberDropdown = function NumberDropdown(_ref) {
  var fields = _ref.fields,
    hideLabel = _ref.hideLabel,
    hideAmount = _ref.hideAmount,
    dictionary = _ref.dictionary,
    showLabel = _ref.showLabel,
    selectAllLabel = _ref.selectAllLabel,
    resultsLabel = _ref.resultsLabel,
    clearAllLabel = _ref.clearAllLabel,
    buttonYellow = _ref.buttonYellow,
    openWithWrapper = _ref.openWithWrapper,
    keepOpenOnChange = _ref.keepOpenOnChange,
    widgetAnalytics = _ref.widgetAnalytics,
    nbHits = _ref.nbHits,
    setFilter = _ref.setFilter,
    facetsName = _ref.facetsName,
    indexDropDown = _ref.indexDropDown,
    firstQuery = _ref.firstQuery,
    firstFilter = _ref.firstFilter,
    wrapperToggle = _ref.wrapperToggle,
    hideDesktopShowButton = _ref.hideDesktopShowButton,
    hideShowButton = _ref.hideShowButton,
    setSubpanelLabel = _ref.setSubpanelLabel,
    onChangeCallback = _ref.onChangeCallback,
    onToggleCallback = _ref.onToggleCallback,
    clearAlllFilters = _ref.clearAlllFilters,
    analytics = _ref.analytics,
    getFilterValue = _ref.getFilterValue,
    resetAllFiltersCallback = _ref.resetAllFiltersCallback,
    _ref$columnsClass = _ref.columnsClass,
    columnsClass = _ref$columnsClass === void 0 ? 'col-md-4' : _ref$columnsClass;
  var location = useLocation();
  var queryParams = qsToObject(location.search);
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isOpen = _React$useState4[0],
    setisOpen = _React$useState4[1];
  var label = get(fields, 'title.jss.value');
  var selectedTagsToDisplay = get(fields, 'preselectedTags.values') || [];
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    inputValue = _React$useState6[0],
    setInputValue = _React$useState6[1];
  var debouncedInput = useDebounce(inputValue, 500);
  var history = useHistory();
  var filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  var rootRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    highLightText = _useState2[0],
    setHighLightText = _useState2[1];
  var clickedTextRef = useRef(false);
  var clearFilter = function clearFilter(e) {
    setisOpen(false);
    setFilter();
    wrapperToggle(true, false);
    removeQueryString(facetsName, history);
    setInputValue('');
    getFilterValue && getFilterValue(fields.name, facetsName, null);
    if (e) {
      e.stopPropagation();
    }
  };
  React.useEffect(function () {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        var preselectedTags = selectedTagsToDisplay.map(function (tag) {
          return get(tag, 'title.value') || get(tag, 'name');
        });
        addQueryString(facetsName, preselectedTags.join(','), history);
        setFilter();
        resetAllFiltersCallback();
      } else {
        clearFilter();
      }
    }
  }, [clearAlllFilters]);
  var submitFilters = function submitFilters(facetsName) {
    setFilter(true);
    if (!keepOpenOnChange) {
      setisOpen(false);
    }
    if (inputValue) {
      addQueryString(facetsName, ">= ".concat(inputValue), history);
      getFilterValue && getFilterValue(fields.name, facetsName, ">= ".concat(inputValue));
    } else {
      deleteQueryString(facetsName, history);
      getFilterValue && getFilterValue(fields.name, facetsName, null);
    }
  };
  var closeDropdwn = function closeDropdwn(event) {
    if (event.target.closest) {
      if (event.target.closest('.filter__field') !== rootRef.current && !event.target.closest('.filter__header')) {
        setisOpen(false);
        wrapperToggle(true);
      } else if (event.target.closest('.filter__header-links')) {
        setisOpen(false);
        wrapperToggle(true);
      }
    } else {
      setisOpen(false);
      wrapperToggle(true);
    }
  };
  var onChangeInput = function onChangeInput(event) {
    setInputValue(event.target.value);
  };
  var handleTextMousedown = function handleTextMousedown() {
    clickedTextRef.current = true;
  };
  var handleTextFocus = function handleTextFocus() {
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  var handleTextBlur = function handleTextBlur() {
    clickedTextRef.current = false;
    setHighLightText(false);
  };
  React.useEffect(function () {
    submitFilters(facetsName);
  }, [debouncedInput]);
  React.useEffect(function () {
    var queries = queryParams["".concat(filterType)];
    if (!queries && selectedTagsToDisplay.length) {
      var preselectedTags = selectedTagsToDisplay.map(function (tag) {
        return get(tag, 'title.value') || get(tag, 'name');
      });
      addQueryString(facetsName, preselectedTags.join(','), history);
      setFilter(true);
    }
    document.body.addEventListener('click', closeDropdwn);
    return function () {
      removeQueryString(facetsName, history);
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field number-dropdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-search-box"
  }, /*#__PURE__*/React.createElement("input", {
    className: "\n              input-text-primary\n              input-search-text\n              ".concat(highLightText ? 'input-text-primary--focused' : '', "\n            "),
    placeholder: label,
    type: "text",
    value: inputValue,
    onChange: onChangeInput,
    onMouseDown: handleTextMousedown,
    onFocus: handleTextFocus,
    onBlur: handleTextBlur
  }))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    columnsClass = _ref2.columnsClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(columnsClass)
  }, children);
};

// export default NumberDropdown;
export default NumberDropdown;
var commonStyles = "c4vfc7";